import * as React from 'react'
import styled from 'styled-components'
import { Link } from 'components'
import get from 'lodash/get'
import { useTranslation } from 'i18n'
import WebpImg from 'components/Image/WebpImg'

/**
 * artistはスタンドアローン用リンクを
 */
const Footer = ({ standalone = null, ...props }) => {
  const { t } = useTranslation('components')

  return (
    <AppContent {...props}>
      <p
        style={{
          color: '#FFF',
          fontSize: 16,
          padding: '10px 0',
          letterSpacing: 3,
          fontWeight: 600,
        }}
      >
        {t('Footer.App.enjoyCardInApp')}
      </p>
      <AppLinkContainer>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Link.AppStore link={get(standalone, 'link.ios')} />
          <Link.GooglePlay link={get(standalone, 'link.android')} />
        </div>
      </AppLinkContainer>
      <div>
        <LogoWebpImage
          webpSrc="/static/images/logo_letter.webp"
          imgSrc="/static/images/logo_letter.png"
          imgProps={{ alt: '' }}
        />
      </div>
    </AppContent>
  )
}

export default Footer

const AppContent = styled.div`
  margin-top: auto;
  padding: 20px 0 30px 0;
  height: 300px;
  background-color: #000000;
  text-align: center;
  display: flex;
  flex-direction: column;
`

const AppLinkContainer = styled.div`
  justify-content: space-between;
  flex-direction: column;
  display: flex;
  align-items: center;
  padding: 0 70px;
  flex: 1 1 auto;
`

const LogoWebpImage = styled(WebpImg)`
  width: 126px;
`
